<template>
  <div v-if="!loading && pathways.length" class="row">
    <div class="col-xl-12">
      <div class="card dashbarod-table-box sdpp">
        <div class="graph-title sdpp__head">
          <h3>My Pathways</h3>
          <router-link to="/employee_courses" class="sdpp__link">Open My Courses &amp; Pathways →</router-link>
        </div>
        <div class="sdpp__grid">
          <router-link v-for="p in pathways" :key="p.id" :to="'/safedig/pathways/' + p.id" class="sdpp__card">
            <div class="sdpp__top">
              <span class="sdpp__kind">Pathway</span>
              <span class="sdpp__pill" :class="pillClass(p)">{{ label(p) }}</span>
            </div>
            <div class="sdpp__title">{{ p.title }}</div>
            <div class="sdpp__bar"><span class="sdpp__fill" :style="{ width: p.progress_pct + '%' }"></span></div>
            <div class="sdpp__meta">{{ p.completed_count }} / {{ p.module_count }} modules · {{ p.progress_pct }}%</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Dashboard block: the learner's pathways as pathways — name, progress,
 * modules done — so they are never mistaken for, or counted among, the
 * assigned courses shown elsewhere on the page. Safe Dig only; renders
 * nothing when the user has no pathways.
 */
export default {
  name: 'SafeDigPathwayProgress',
  data() {
    return { loading: true, pathways: [] };
  },
  created() {
    this.$http.get('safedig/my-learning')
      .then(resp => { this.pathways = (resp.data && resp.data.pathways) || []; })
      .catch(() => { this.pathways = []; })
      .finally(() => { this.loading = false; });
  },
  methods: {
    label(p) {
      if (p.pathway_status === 'completed') return 'Completed';
      return p.completed_count > 0 ? 'In progress' : 'Not started';
    },
    pillClass(p) {
      return {
        'sdpp__pill--green': p.pathway_status === 'completed',
        'sdpp__pill--blue': p.pathway_status !== 'completed' && p.completed_count > 0,
        'sdpp__pill--gray': p.pathway_status !== 'completed' && p.completed_count === 0,
      };
    },
  },
};
</script>

<style scoped>
.sdpp { --sd-accent: #3e7799; --sd-accent-soft: rgba(62, 119, 153, 0.14); --sd-navy: #1e3a5f; --sd-muted: #475569; --sd-border: #e2e8f0; }
.sdpp__head { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.sdpp__link { font-size: 0.85rem; font-weight: 600; color: var(--sd-accent); text-decoration: none; }
.sdpp__link:hover { text-decoration: underline; }
.sdpp__grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 0.85rem; padding: 0 1rem 1rem; }
.sdpp__card { display: block; background: #fff; border: 1px solid var(--sd-border); border-left: 4px solid var(--sd-accent); border-radius: 12px; padding: 0.9rem 1rem; text-decoration: none; color: inherit; transition: border-color 0.15s ease; }
.sdpp__card:hover { border-color: var(--sd-accent); text-decoration: none; }
.sdpp__top { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; }
.sdpp__kind { font-size: 0.65rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--sd-accent); background: var(--sd-accent-soft); border-radius: 4px; padding: 0.1rem 0.4rem; }
.sdpp__pill { font-size: 0.7rem; font-weight: 600; border-radius: 999px; padding: 0.12rem 0.5rem; }
.sdpp__pill--green { background: #dcfce7; color: #15803d; }
.sdpp__pill--blue { background: var(--sd-accent-soft); color: var(--sd-accent); }
.sdpp__pill--gray { background: #f1f5f9; color: var(--sd-muted); }
.sdpp__title { font-weight: 700; color: var(--sd-navy); margin: 0.5rem 0 0.55rem; font-size: 0.95rem; }
.sdpp__bar { height: 8px; border-radius: 999px; background: #f1f5f9; overflow: hidden; }
.sdpp__fill { display: block; height: 100%; background: var(--sd-accent); }
.sdpp__meta { font-size: 0.75rem; color: var(--sd-muted); margin-top: 0.4rem; }
</style>
